import React, { useState } from "react";
import DeletePost from "./DeletePost";
import "./edit_deletePost.css";
import { Box, Button, Stack } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const ThreeDot_Post_Popup = ({
  setPostEdit,
  setPostThreedot,
  communityId,
  post_id,
  members,
  post,
  refetch1,
  setOpenPopup,
}) => {
  console.log(communityId, "communityId");
  const [delet1, setDelet1] = useState(false);
  const user_id = JSON.parse(localStorage.getItem("Teacher_id"));

  const isAdmin =
    members &&
    members.some((member) =>
      member.admins_id
        ? member.admins_id.some((admin) => admin.admin.id === user_id)
        : member.teachers_id?.some(
            (teacher) =>
              teacher.teacher.id === user_id && teacher.role === "admin",
          ),
    );

  const isModerator =
    members &&
    members.some((member) =>
      member.teachers_id?.some(
        (teacher) =>
          teacher.teacher.id === user_id && teacher.role === "moderator",
      ),
    );

  return (
    <>
      <Box
        sx={{
          p: 2,
          borderRadius: 2,
          bgcolor: "background.paper",
          boxShadow: 3,
          minWidth: 150,
        }}
      >
        <Stack spacing={2}>
          {post?.user_id?.id === user_id && (
            <Button
              variant="contained"
              color="warning"
              startIcon={<EditIcon />}
              fullWidth
              sx={{ textTransform: "none", whiteSpace: "nowrap" }}
              onClick={() => {
                setPostEdit(true);
                setPostThreedot(false);
              }}
            >
              Edit Post
            </Button>
          )}
          {(isAdmin || isModerator || post?.user_id?.id === user_id) && (
            <Button
              variant="outlined"
              color="error"
              startIcon={<DeleteIcon />}
              fullWidth
              sx={{ textTransform: "none", whiteSpace: "nowrap" }}
              onClick={() => setDelet1(true)}
            >
              Delete Post
            </Button>
          )}
        </Stack>
      </Box>

      {delet1 && (
        <DeletePost
          setDelet1={setDelet1}
          communityId={communityId}
          post_id={post_id}
          refetch1={refetch1}
          setOpenPopup={setOpenPopup}
        />
      )}
    </>
  );
};

export default ThreeDot_Post_Popup;
